/**
 * SideRail — navigation latérale (tablette uniquement, 768–1023px).
 * Même registre role-aware que BottomNav (config/navigation.js) rendu en rail
 * vertical à gauche. Le téléphone garde la barre du bas, l'ordinateur la nav du
 * Header. La visibilité par plage est gérée en CSS ; ce composant ne fait que
 * poser le drapeau `body.has-side-rail` (offset du contenu + déclutter Header).
 */

import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';
import { getNavTabs, activeTabKey } from '../../config/navigation.js';
import GeIcon from '../common/GeIcon.jsx';
import './SideRail.css';

function SideRail() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  const tabs = isAuthenticated && user ? getNavTabs(user) : [];
  const shown = tabs.length > 0;

  useEffect(() => {
    document.body.classList.toggle('has-side-rail', shown);
    return () => document.body.classList.remove('has-side-rail');
  }, [shown]);

  if (!shown) return null;

  const active = activeTabKey(tabs, location.pathname);

  return (
    <nav className="side-rail" aria-label="Navigation principale">
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <Link
            key={t.key}
            to={t.to}
            className={`sr-tab${t.primary ? ' sr-primary' : ''}${isActive ? ' sr-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="sr-icon" aria-hidden="true"><GeIcon name={t.icon} /></span>
            <span className="sr-label">{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}

export default SideRail;
